import React, {ReactNode} from 'react';
import {Root, TooltipPlacement, TooltipText} from './styled';

interface Props {
  text: string;
  children: ReactNode;
  minWidth?: number;
  placement?: TooltipPlacement;
}

export function Tooltip({children, text, minWidth = 0, placement = 'top'}: Props) {
  return (
    <Root
      onMouseEnter={(e) => e.currentTarget.classList.add('hover')}
      onMouseLeave={(e) => e.currentTarget.classList.remove('hover')}
    >
      <TooltipText minWidth={minWidth} $placement={placement}>{text}</TooltipText>
      {children}
    </Root>
  );
}

Tooltip.defaultProps = {
  minWidth: 0,
  placement: 'top',
};
